import Controller from "@ember/controller"
import { computed, get } from "@ember/object"
import { alias } from "@ember/object/computed"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import ObjectProxy from "@ember/object/proxy"
import { inject as service } from "@ember/service"
import belongsTo from "cc-frontend/helpers/belongs-to"
import _ from "lodash"
import findDocument from "../../helpers/find-document"
import findMany from "../../helpers/find-many"

class ObjectPromiseProxy extends ObjectProxy.extend(PromiseProxyMixin) {}

export default class PlanbookStandardsController extends Controller {
  @service("ember-store")
  store

  @service
  rpc

  queryParams = ["courseIds", "standardSetId", "showStandardsNotCovered", "headerText"]

  @computed("showStandardsNotCovered")
  get showStandardsNotCoveredAsBool() {
    return get(this, "showStandardsNotCovered") === "true"
  }

  courseIds = []

  @computed
  get currentDate() {
    return new Date()
  }

  @alias("model.planbook")
  planbook

  @belongsTo("planbook", "owner")
  owner

  @findMany("courseIds", "course")
  courses

  @findDocument("standardSetId", "standard-set")
  selectedStandardSet

  @computed("courses.isFulfilled")
  get courseTitles() {
    return _.map(get(this, "courses.content"), (course) => get(course, "attributes.title"))
  }

  @computed("standardSetId", "courseIds.[]")
  get hierarchicalStandardsReport() {
    let courseIds = get(this, "courseIds")
    let standardSetId = get(this, "standardSetId")
    if (courseIds.length > 0 && standardSetId) {
      return ObjectPromiseProxy.create({
        promise: get(this, "rpc").execute("STANDARDS_REPORT", courseIds, [standardSetId]),
      })
    }
  }

  @computed("selectedStandardSet.attributes.standards")
  get standards() {
    return _(get(this, "selectedStandardSet.attributes.standards"))
      .values()
      .sortBy("position")
      .value()
  }
}
